module.exports = __webpack_public_path__ + "media/images/icons/filled/car-0c2e2cf9c5632a6db14fdbadd8493dd0.svg";